import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import UserService from "../services/UserService";
import { Container, Row, Col } from "react-bootstrap";
import axios from "axios";

const serverConfig = require("./../config/server.js");

const Header = ({
  token,
  isMarketplacePage,
  notificationsCount,
  refreshNotifications,
  setIndustry,
  setCompany,
  leftNode,
  isLoanUnderwrite = false,
  productLabel = "",
  fixed = false,
  disableSidebarToggle = false,
  rightNavNavigate = false,
}) => {
  const [notificationStatus, setNotificationStatus] = useState(true);
  // activePanel can be: null, 'agora', or 'atlas'
  const [activePanel, setActivePanel] = useState(null);
  const [isSupportIconHovered, setIsSupportIconHovered] = useState(false);
  const navigate = useNavigate();

  const notificationIconRef = useRef();
  const userRef = useRef();

  // Sidebars always start off and stay off across refresh — ignore any
  // previously-saved panel and persist the closed state.
  useEffect(() => {
    setActivePanel(null);
    document.body.classList.add('rightnav-collapsed');
    try {
      localStorage.setItem('rightnavActivePanel', 'null');
      localStorage.setItem('rightnavCollapsed', 'true');
    } catch (e) {}
  }, [disableSidebarToggle]);

  const handlePanelToggle = (panel) => {
    // On full-screen iframe pages: don't open right sidebar, navigate instead
    if (disableSidebarToggle) {
      if (rightNavNavigate) {
        const routeMap = { support: "/support", agora: "/agora", atlas: "/atlas" };
        const to = routeMap[panel];
        if (to) navigate(to);
      }
      return;
    }
    
    setActivePanel(prev => {
      // If clicking the same panel, close it; otherwise switch to new panel
      const next = prev === panel ? null : panel;
      try {
        if (next) {
          document.body.classList.remove('rightnav-collapsed');
          localStorage.setItem('rightnavActivePanel', next);
          localStorage.setItem('rightnavCollapsed', 'false');
        } else {
          document.body.classList.add('rightnav-collapsed');
          localStorage.setItem('rightnavActivePanel', 'null');
          localStorage.setItem('rightnavCollapsed', 'true');
        }
        // Dispatch event for RightAside to sync with mode info
        window.dispatchEvent(new CustomEvent('rightnav-toggle', { detail: { panel: next } }));
      } catch (e) {}
      return next;
    });
  };

  const handleClickOutside = (e) => {
    try {
      if (
        notificationIconRef.current &&
        !notificationIconRef.current.contains(e.target)
      ) {
        setShowNotification(false);
      }
      if (userRef.current && !userRef.current.contains(e.target)) {
        setShowUserButton(false);
      }
    } catch (err) {
      // ignore
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    // Call backend to sync logout with Discourse/Zammad
    const jwt = token || sessionStorage.getItem("token");
    if (jwt) {
      axios
        .post(serverConfig.api_base_url + "user_logout", { token: jwt })
        .catch((err) => console.log("Logout sync error:", err))
        .finally(() => {
          sessionStorage.clear();
          UserService.doLogout();
        });
    } else {
      sessionStorage.clear();
      UserService.doLogout();
    }
  };

  const [showNotification, setShowNotification] = useState(false);
  const [showUserButton, setShowUserButton] = useState(false);
  const handleToggleNotification = () => {
    setShowNotification(!showNotification);
  };
  const handleToggleUserButton = () => {
    setShowUserButton(!showUserButton);
  };

  const [newNotificationsCount, setNewNotificationsCount] = useState("");
  const [notifications, setNotifications] = useState([]);

  const initialName = localStorage.getItem("cachedCompanyName") || "";
  const initialLogo = localStorage.getItem("cachedCompanyLogo") || "";

  const [companyName, setCompanyName] = useState(initialName);
  const [companyLogo, setCompanyLogo] = useState(initialLogo);

  useEffect(() => {
    // Restore name and logo from localStorage on mount
    try {
      const cachedLogo = localStorage.getItem("cachedCompanyLogo");
      const cachedName = localStorage.getItem("cachedCompanyName");
      if (cachedLogo) {
        setCompanyLogo(cachedLogo);
      }
      if (cachedName) {
        setCompanyName(cachedName);
      }
    } catch (e) {
      console.log("localStorage access error:", e);
    }

    if (token !== null && token !== undefined) {
      axios
        .post(serverConfig.api_base_url + "company_details_get", {
          token: token,
        })
        .then((response) => {
          console.log("company_details_get response:", response);
          if (response.data.status === 200) {
            if (response.data.companyName) {
              setCompanyName(response.data.companyName);
              // Cache name in localStorage
              try {
                localStorage.setItem(
                  "cachedCompanyName",
                  response.data.companyName
                );
              } catch (e) {
                console.log("localStorage write error:", e);
              }
              if (setCompany) {
                setCompany(response.data.companyName);
              }
            }
            if (response.data.companyLogo) {
              setCompanyLogo(response.data.companyLogo);
              // Cache logo in localStorage
              try {
                localStorage.setItem(
                  "cachedCompanyLogo",
                  response.data.companyLogo
                );
              } catch (e) {
                console.log("localStorage write error:", e);
              }
            }
            if (setIndustry) {
              if (response.data.companyIndustry) {
                setIndustry(response.data.companyIndustry);
              }
            }
          } else if (response.data.status === 301) {
            handleLogout();
          } else {
            alert(response.data.message);
          }
        })
        .catch((err) => console.log("error is", err));
    }
  }, [token]);

  useEffect(() => {
    console.log(token);
    if (token !== null && token !== undefined) {
      axios
        .post(serverConfig.api_base_url + "notification_get_list", {
          token: token,
          mark_read: 0,
        })
        .then((response) => {
          console.log("notification_get_list response", response);
          if (response.data.status === 200) {
            if (response.data.items !== null) {
              let items = response.data.items;
              setNewNotificationsCount(
                items.filter((item) => item.read === "N").length
              );
              console.log("notifications", items);
              //setNotifications(items.filter(item => item.read === 'N').sort((a, b) => b.stamp.localeCompare(a.stamp)).slice(0, 5));
              setNotifications(
                items
                  .filter((item) => item.read === "N")
                  .reverse()
                  .slice(0, 5)
              );
            }
          } else if (response.data.status === 301) {
            handleLogout();
          } else {
            alert(response.data.message);
          }
        })
        .catch((err) => console.log("error is", err));
    }
  }, [token, refreshNotifications]);

  return (
    <header style={{ backgroundColor: '#0c1017', zIndex: 50, position: fixed ? 'fixed' : 'relative', top: 0, left: 0, right: 0, }}>
      <Container fluid>
        <Row className="align-items-center" style={{ display: "flex" }}>
          <Col
            className="header-left"
            style={{ flex: 1, minWidth: 0, overflow: "hidden" }}
          >
            {leftNode ? (
              leftNode
            ) : (
              <h1
                style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  margin: 0,
                }}
              >
                <span className="company-name">
                  <img src={companyLogo && companyLogo} className="company-logo-img"/>{" "}
                  <span className="txt-gray ms-2">
                    {companyName && companyName}
                  </span>
                </span>{" "}
                <span onClick={() => {
                  navigate("/dashboard");
                }} style={{ cursor: "pointer" }}>
                The Enterprise Decision OS
                </span>
              </h1>
            )}
          </Col>
          <Col
            xs="auto"
            className="header-right"
            style={{
              display: "flex",
              gap: "20px",
              alignItems: "center",
              flexShrink: 0,
            }}
          >
            {productLabel && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  margin: 0,
                  padding: "0 12px 0 0",
                  borderRight: "1px solid var(--colorYellow)",
                  height: "30px",
                }}
              >
                <span style={{ color: "var(--colorYellow)" }}>{productLabel}</span>
              </div>
            )}
            <div
              style={{
                display: "flex",
                gap: "15px",
                alignItems: "center",
                margin: 0,
                padding: "0 12px 0 0",
                borderRight: "1px solid var(--colorYellow)",
                height: "30px",
              }}
            >
              <button
                onClick={() => handlePanelToggle('support')}
                title="Support"
                onMouseEnter={() => setIsSupportIconHovered(true)}
                onMouseLeave={() => setIsSupportIconHovered(false)}
                style={{ display: "flex", alignItems: "center", background: "none", border: "none", cursor: (disableSidebarToggle && !rightNavNavigate) ? "default" : "pointer", padding: 0 }}
              >
                <img
                  src={require("./../assets/images/icons/icon-support-health.png")}
                  alt="Support"
                  width="30"
                  height="30"
                  style={{
                    filter:
                      (!disableSidebarToggle && (activePanel === "support" || isSupportIconHovered))
                        ? "brightness(0) saturate(100%) invert(70%) sepia(82%) saturate(1835%) hue-rotate(341deg) brightness(103%) contrast(98%)"
                        : "grayscale(100%)",
                    transition: "filter 0.2s ease",
                  }}
                />
              </button>
              <button
                onClick={() => handlePanelToggle('agora')}
                title="Agora"
                style={{ display: "flex", alignItems: "center", background: "none", border: "none", cursor: (disableSidebarToggle && !rightNavNavigate) ? "default" : "pointer", padding: 0 }}
              >
                <svg
                  className="header-icon-link"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 640 512"
                  width="40"
                  height="40"
                  style={{
                    color: (!disableSidebarToggle && activePanel === "agora") ? "var(--colorYellow)" : "#8B8B8B",
                    filter: (!disableSidebarToggle && activePanel === "agora") ? "none" : "grayscale(100%)",
                    transition: "color 0.2s ease, filter 0.2s ease",
                  }}
                >
                  <g transform="scale(0.93) translate(28 20)">
                    <path
                      d="M200 240c16.94 0 32.09 10.72 37.73 26.67c5.891 16.66 24.17 25.39 40.84 19.5c16.66-5.891 25.39-24.17 19.5-40.84C287.2 214.7 262.8 191.6 233.1 181.5l79.68-22.76c16.98-4.859 26.83-22.56 21.97-39.56C329.9 102.2 312.2 92.35 295.2 97.24L196 125.6l80.82-69.28c13.42-11.5 14.97-31.7 3.469-45.12C268.8-2.24 248.6-3.803 235.2 7.713l-100.4 86.09l22.33-48.39c7.391-16.05 .3906-35.06-15.66-42.47C125.4-4.412 106.4 2.525 98.94 18.6L14.92 206.6C5.082 228.6 0 252.5 0 276.6C0 335.9 48.1 384 107.4 384l99.9-.0064c31.87-2.289 61.15-19.35 79.13-46.18c9.828-14.69 5.891-34.56-8.781-44.41C263 283.6 243.1 287.5 233.3 302.2C225.8 313.3 213.4 320 200 320c-22.06 0-40-17.94-40-40C160 257.9 177.9 240 200 240zM532.6 128l-99.9 .004c-31.87 2.289-61.15 19.35-79.13 46.18c-9.828 14.69-5.891 34.56 8.781 44.41c14.66 9.812 34.55 5.906 44.41-8.781C414.2 198.7 426.6 191.1 440 191.1c22.06 0 40 17.94 40 40c0 22.06-17.94 39.1-40 39.1c-16.94 0-32.09-10.72-37.73-26.67c-5.891-16.66-24.17-25.39-40.84-19.5c-16.66 5.891-25.39 24.17-19.5 40.84c10.84 30.64 35.23 53.77 64.96 63.8l-79.68 22.76c-16.98 4.859-26.83 22.56-21.97 39.56c4.844 16.98 22.56 26.86 39.56 21.97l99.2-28.34l-80.82 69.28c-13.42 11.5-14.97 31.7-3.469 45.12c11.52 13.42 31.73 14.98 45.13 3.469l100.4-86.09l-22.33 48.39c-7.391 16.05-.3906 35.06 15.66 42.47c16.02 7.359 35.05 .4219 42.47-15.65l84.02-188C634.9 283.4 640 259.5 640 235.4C640 176.1 591.9 128 532.6 128z"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="18"
                      strokeLinejoin="round"
                    />
                  </g>
                </svg>
              </button>
              <button
                onClick={() => handlePanelToggle('atlas')}
                title="Atlas"
                style={{ display: "flex", alignItems: "center", background: "none", border: "none", cursor: (disableSidebarToggle && !rightNavNavigate) ? "default" : "pointer", padding: 0 }}
              >
                <svg
                  className="header-icon-link"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 576 512"
                  width="40"
                  height="40"
                  style={{
                    color: (!disableSidebarToggle && activePanel === "atlas") ? "var(--colorYellow)" : "#8B8B8B",
                    filter: (!disableSidebarToggle && activePanel === "atlas") ? "none" : "grayscale(100%)",
                    transition: "color 0.2s ease, filter 0.2s ease",
                  }}
                >
                  <g transform="scale(0.93) translate(23 20)">
                    <path
                      d="M386.539 111.485l15.096 248.955-10.979-.275c-36.232-.824-71.64 8.783-102.657 27.997-31.016-19.214-66.424-27.997-102.657-27.997-45.564 0-82.07 10.705-123.516 27.723L93.117 129.6c28.546-11.803 61.484-18.115 92.226-18.115 41.173 0 73.836 13.175 102.657 42.544 27.723-28.271 59.013-41.721 98.539-42.544zM569.07 448c-25.526 0-47.485-5.215-70.542-15.645-34.31-15.645-69.993-24.978-107.871-24.978-38.977 0-74.934 12.901-102.657 40.623-27.723-27.723-63.68-40.623-102.657-40.623-37.878 0-73.561 9.333-107.871 24.978C55.239 442.236 32.731 448 8.303 448H6.93L49.475 98.859C88.726 76.626 136.486 64 181.775 64 218.83 64 256.984 71.685 288 93.095 319.016 71.685 357.17 64 394.225 64c45.289 0 93.049 12.626 132.3 34.859L569.07 448zm-43.368-44.741l-34.036-280.246c-30.742-13.999-67.248-21.41-101.009-21.41-38.428 0-74.385 12.077-102.657 38.702-28.272-26.625-64.228-38.702-102.657-38.702-33.761 0-70.267 7.411-101.009 21.41L50.298 403.259c47.211-19.487 82.894-33.486 135.045-33.486 37.604 0 70.817 9.606 102.657 29.644 31.84-20.038 65.052-29.644 102.657-29.644 52.151 0 87.834 13.999 135.045 33.486z"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="18"
                      strokeLinejoin="round"
                    />
                  </g>
                </svg>
              </button>
            </div>
            <div
              className="notification"
              ref={notificationIconRef}
              style={{
                display: "flex",
                alignItems: "center",
                margin: 0,
                padding: "0",
                height: "30px",
              }}
            >
              <button
                className={notificationStatus ? "notification-true" : null}
                onClick={handleToggleNotification}
              >
                <img
                  src={require("./../assets/images/icons/notification-icon.png")}
                  alt="Notification"
                />
                {newNotificationsCount !== "" && (
                  <span className="count">
                    {notificationsCount
                      ? notificationsCount
                      : newNotificationsCount}
                  </span>
                )}
              </button>
              <ul
                className={
                  "notification-list " + (showNotification ? "show" : "")
                }
              >
                {notifications.length > 0 &&
                  notifications.map((item, index) => (
                    <li key={index}>
                      <span>{item.notification_message}</span>
                    </li>
                  ))}
                <li>
                  <Link to="/notifications">See all</Link>
                </li>
              </ul>
            </div>
            <div
              className="user"
              ref={userRef}
              style={{
                display: "flex",
                gap: "8px",
                alignItems: "center",
                margin: 0,
                padding: "0 12px",
                height: "30px",
              }}
            >
              <span className="text">
                Hello {UserService.getWelcomeName()}!
              </span>
              <button className="user-true" onClick={handleToggleUserButton}>
                <img
                  src={require("./../assets/images/icons/user-icon.png")}
                  alt="User"
                  style={{ height: "30px" }}
                />
              </button>
              <ul className={"user-list " + (showUserButton ? "show" : "")}>
                <li>
                  <Link to="/profile">Profile</Link>
                </li>
                <li>
                  <span onClick={handleLogout}>Log out</span>
                </li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    </header>
  );
};

export default Header;
